export const POSITION_START = 'POSITION_START'